import React from "react";
import { RestaurantPublicInfoEditor } from "../features/restaurant-public-info";
import { withRestaurantId } from "../shared/components/layout";

const RestaurantPublicInfoEditorWithId = withRestaurantId(RestaurantPublicInfoEditor);

const RestaurantPublicInfoPage: React.FC = () => {
  return <RestaurantPublicInfoEditorWithId />;
};

export default RestaurantPublicInfoPage;
